import React from 'react';
import TrainRow from "~/Pages/RsvpRegistration/Travel/TrainRow";
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';

const Train = ({onChange, values, errors, ...props}) => {

    return (
        <>
        <hr/>
        <div className="train-tab row">
            <div className="col-12 form-group mb-0">
                <h3><TextTranslate name="travel-travelling-by" fallback="Travelling by" textOnly/> <strong><TextTranslate name="travel-train" fallback="Train" textOnly/></strong></h3>
                <p className="d-block"><TextTranslate name="travel-travelling-by-note" fallback="Please fill out the necessary information." textOnly/></p>
                <TrainRow values={values} errors={errors} onChange={onChange} />
            </div>
        </div>
        </>
    )
}

export default Train;
